import { render, staticRenderFns } from "./Chrome.vue?vue&type=template&id=bfd990d6"
import script from "./Chrome.vue?vue&type=script&lang=js"
export * from "./Chrome.vue?vue&type=script&lang=js"
import style0 from "./Chrome.vue?vue&type=style&index=0&id=bfd990d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports